import { render } from "./WESSystem.vue?vue&type=template&id=5b4909d0&scoped=true"
import script from "./WESSystem.vue?vue&type=script&lang=js"
export * from "./WESSystem.vue?vue&type=script&lang=js"

import "./WESSystem.vue?vue&type=style&index=0&id=5b4909d0&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5b4909d0"]])

export default __exports__